import styled from 'styled-components';
import { CropPriceSummaryCard } from './CropPriceSummaryCard';
import { Icon } from '../../../../components/common/icon/Icon';
import { FavoriteButton } from './FavoriteButton';
import { findCropFavorite } from '../../../../utils/finder/findCropFavorite.util';
import { ICropFavoriteInfo } from '../../../../api/crop-trends/getCropFavorite';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';

enum LastYearWeeklyTrend {
  UP = 'UP',
  DOWN = 'DOWN',
  STABLE = 'STABLE',
  NO_DATA = 'NO_DATA',
}

interface CropPriceSubCategoryItemProps {
  label: string;
  todayAveragePrice: number;
  previousPrice: number;
  changeAmount: number | null;
  changeRate: number | null;
  lastYearWeeklyTrend: LastYearWeeklyTrend;
  largeCategoryCode: string;
  middleCategoryCode: string;
  middleCategoryName: string;
  smallCategoryCode: string;
  myCropFavorite: ICropFavoriteInfo[];
  onFavoriteClick?: () => void;
  onItemClick?: () => void;
}

export const CropPriceSubCategoryItem = ({
  label,
  todayAveragePrice,
  previousPrice,
  changeAmount,
  changeRate,
  lastYearWeeklyTrend,
  largeCategoryCode,
  middleCategoryCode,
  middleCategoryName,
  smallCategoryCode,
  myCropFavorite,
  onFavoriteClick,
  onItemClick,
}: CropPriceSubCategoryItemProps) => {
  const { isFavoriteCrop } = findCropFavorite({
    largeCategoryCode,
    middleCategoryCode,
    smallCategoryCode,
    cropFavoritesInfos: myCropFavorite,
  });

  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return (
    <Container>
      <ItemContainer onClick={onItemClick} as="button" type="button" id={`${middleCategoryName}-${label}`}>
        <CropPriceSummaryCard
          label={label}
          todayAveragePrice={todayAveragePrice}
          previousPrice={previousPrice}
          changeAmount={changeAmount}
          changeRate={changeRate}
          lastYearWeeklyTrend={lastYearWeeklyTrend}
          labelVariant="normal"
        />
      </ItemContainer>
      <FavoriteButtonWrapper onClick={onFavoriteClick} as="button" type="button">
        <FavoriteButton isFavorite={isUserLoggedIn && isFavoriteCrop} />
      </FavoriteButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #ececf3);

  &:last-child {
    border-bottom: none;
  }
`;

const ItemContainer = styled.div`
  flex: 1;

  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const FavoriteButtonWrapper = styled.div`
  display: flex;
  width: 50px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;
